import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { poweredByContentful } from '../../../../locales/en-GB/data/footer.data';
import {
  ChevronRightAtom,
  GlobeIconAtom,
} from '../../atoms/icon-atoms/nav-icon-atoms';
import { CyberEssentialsLogoAtom } from '@atoms/logo-atoms/logo-atoms';
import { ContentfulLinkAtom } from '../../atoms/link-atoms/link-atoms';
import { MobileSocialLinks } from '../../atoms/navbar-atoms/mobile-social-links/mobile-social-links';
import { MobileMenuSecondLevel } from '../mobile-menu-second-level/mobile-menu-second-level';
import {
  Wrapper,
  MenuItem,
  MenuFooter,
  FooterText,
  FooterLinks,
  Copyright,
  FooterLink,
  LanguageWrapper,
  AddressWrapper,
  Address,
} from './mobile-menu.styles';
import { useMobileFooterText } from '../../hooks/use-mobile-footer-text';
import { GTM_ID } from '../../../../common/constants/gtmIds';
import vars from '../../variables';

export const MobileMenu = ({
  selectedTab,
  tabs,
  columnData,
  footerData,
  handleClick,
  handleBackClick,
  handleReset,
  isLanguagesOpen,
  languages,
  handleLanguagesClick,
  locale,
}) => {
  const footerText = useMobileFooterText(locale);
  const setLanguageFromLocale = () => {
    if (locale === 'pt') return 'Pt';
    if (locale === 'fr') return 'Fr';
    if (locale === 'es') return 'Es';
    return 'En';
  };

  return (
    <>
      <AnimatePresence>
        {(selectedTab || isLanguagesOpen) && (
          <MobileMenuSecondLevel
            handleBackClick={handleBackClick}
            handleReset={handleReset}
            tabs={tabs}
            columnData={columnData}
            languages={languages}
            isLanguagesOpen={isLanguagesOpen}
            selectedTab={selectedTab}
          />
        )}
      </AnimatePresence>
      <motion.div
        initial={{
          x: '100%',
        }}
        animate={{ x: '0%' }}
        transition={{ duration: 0.2 }}
      >
        <Wrapper>
          {tabs.map((tab, i) => {
            return (
              <MenuItem
                value={tab.contentful_id}
                key={i}
                onClick={handleClick}
                data-gtm-id={`${
                  GTM_ID.MAIN_NAV_LINK
                }-${tab.title.toLowerCase().split(' ').join('-')}`}
              >
                <span>{tab.title}</span>
                <ChevronRightAtom />
              </MenuItem>
            );
          })}
          <MenuItem
            onClick={handleLanguagesClick}
            data-gtm-id={GTM_ID.MAIN_NAV_LINK_LANG}
          >
            <LanguageWrapper>
              <GlobeIconAtom
                width="28"
                height="28"
                stroke="0"
                fill={vars.coreDarkGrey}
              />
              <span>{setLanguageFromLocale()}</span>
            </LanguageWrapper>
            <ChevronRightAtom />
          </MenuItem>
          <MenuFooter>
            <Copyright>{footerText.copyRight}</Copyright>
            <AddressWrapper>
              <Address>
                {footerText.registrationNumbers.map((text, i) => {
                  return <FooterText key={i}>{text}</FooterText>;
                })}
              </Address>
              <CyberEssentialsLogoAtom />
            </AddressWrapper>
            <FooterLinks>
              {footerData.map((link, i) => {
                return (
                  <FooterLink key={i} to={link.path}>
                    {link.title}
                  </FooterLink>
                );
              })}
            </FooterLinks>

            <ContentfulLinkAtom
              url={poweredByContentful.url}
              text={poweredByContentful.text}
            />
          </MenuFooter>
        </Wrapper>
      </motion.div>
      <motion.div
        key="social-links-animation"
        initial={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          y: 68,
        }}
        animate={{ y: 0, transition: { delay: 0.2, duration: 0.2 } }}
      >
        <MobileSocialLinks withAnimation={true} />
      </motion.div>
    </>
  );
};
